import { DAY_GRID_WIDTH } from '@spa/scenes/Plannings/redux/selectors'
import type { PropsWithChildren, FC } from 'react'
import React from 'react'

type Props = {
  className?: string
} & React.HTMLProps<HTMLDivElement>

export const DayWidth: FC<PropsWithChildren<Props>> = React.memo(
  ({ children, className = '', ...other }) => {
    return (
      <div
        {...other}
        className={className}
        style={{ ...other?.style, width: DAY_GRID_WIDTH }}
      >
        {children}
      </div>
    )
  }
)
